export default "https://client.chat.ao.com/1289/beta/without-externals/assets/sounds/agentConnected.mp3?0e57fd6242848bc0bdcf469b00a5c02c";